module.exports = __webpack_public_path__ + "img/Screen Shot 2019-05-27 at 3.31.32 PM.64f291e7.png";